export default __webpack_public_path__ + "static/media/PinterestSVG.0725ed6e.svg";